import Text from '../../Text'

import * as styles from './ChartLegendText.module.css'

// Recharts colors legend text after its series; only the icon keeps it.
function ChartLegendText({ children }) {
  return (
    <Text isSecondary className={styles.text}>
      {children}
    </Text>
  )
}

export default ChartLegendText
